// extracted by mini-css-extract-plugin
export default {"modal":"Modal_modal__UD7ep","modal_background":"Modal_modal_background__yx1kU","modal_cls_btn":"Modal_modal_cls_btn__d6xEr","modal_content":"Modal_modal_content__6IkAw"};